/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for ActivityType controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { UpdateActivityTypeRequest, RequestOptions, GetActivityTypesResponse, CreateActivityTypeRequest, CreateActivityTypeResponse, GetActivityTypeSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class ActivityTypeService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    updateActivityType(id: number, updateActivityTypeRequest: UpdateActivityTypeRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateActivityType(id: number, updateActivityTypeRequest: UpdateActivityTypeRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateActivityType(id: number, updateActivityTypeRequest: UpdateActivityTypeRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateActivityType(id: number, updateActivityTypeRequest: UpdateActivityTypeRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/ActivityType/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateActivityTypeRequest, requestOptions);
    }

    deleteActivityType(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteActivityType(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteActivityType(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteActivityType(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/ActivityType/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getActivityTypes(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetActivityTypesResponse>;
    getActivityTypes(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetActivityTypesResponse>>;
    getActivityTypes(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetActivityTypesResponse>>;
    getActivityTypes(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/ActivityType`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createActivityType(createActivityTypeRequest: CreateActivityTypeRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateActivityTypeResponse>;
    createActivityType(createActivityTypeRequest: CreateActivityTypeRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateActivityTypeResponse>>;
    createActivityType(createActivityTypeRequest: CreateActivityTypeRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateActivityTypeResponse>>;
    createActivityType(createActivityTypeRequest: CreateActivityTypeRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/ActivityType`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createActivityTypeRequest, requestOptions);
    }

    getActivityTypeSelect(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetActivityTypeSelectResponse>;
    getActivityTypeSelect(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetActivityTypeSelectResponse>>;
    getActivityTypeSelect(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetActivityTypeSelectResponse>>;
    getActivityTypeSelect(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/ActivityType/Select`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
